<template>
	<svg
		v-if="
			!config.getConfigContent('logoHide', false) &&
			!config.getConfigContent('replaceLogo', false)
		"
		v-bind="$attrs"
		width="593"
		height="267"
		viewBox="0 0 593 267"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="{ 'cursor-pointer': clickable }"
		@click="onClick"
	>
		<path
			d="M262.5 266.31L376.8 65.9101H412.7L297.3 266.41L297 265.21L262.5 266.31Z"
			fill="#5CBB57"
		/>
		<path
			d="M289.1 219.91L361.6 154.81L297.3 266.51L279.1 245.01L289.1 219.91Z"
			fill="#51954B"
		/>
		<path
			d="M515.8 146.01C550.1 146.01 575.7 172.21 575.7 206.21C575.7 240.21 550.1 266.41 515.8 266.41C481.5 266.41 455.9 240.21 455.9 206.21C455.9 172.21 481.5 146.01 515.8 146.01ZM515.8 235.71C530.9 235.71 542.5 222.61 542.5 206.21C542.5 189.81 530.9 176.71 515.8 176.71C500.7 176.71 489.1 189.81 489.1 206.21C489.1 222.61 500.7 235.71 515.8 235.71Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M450.2 203.41C450.2 164.71 423.8 146.01 395.7 146.01C387.374 145.977 379.132 147.68 371.5 151.01L336.1 211.71C338.5 244.91 364.8 266.41 400.6 266.41C415.7 266.41 432.8 262.91 443.9 255.91V226.11C431.8 234.31 417.9 238.71 405.2 238.71C389 238.71 376 231.41 372.1 215.51H449.5C449.962 211.493 450.196 207.453 450.2 203.41ZM371.8 193.11C374.8 180.01 384.3 173.21 395.2 173.21C406.6 173.21 415.6 180.71 417.7 193.11H371.8Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M238.2 153.51C224.9 149.81 208.2 153.51 202.6 163.91V151.71H165.7V266.21H202.7V216.71C202.7 186.31 229.1 180.31 243.5 186.01L238.2 153.51Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M12 103.01H57.6C86.6 103.01 109 107.71 125.9 119.41C145.9 133.31 157.1 156.21 157.1 184.11C157.1 209.71 147.4 231.51 130.1 245.71C113.5 259.21 90.1 265.71 56 265.71H12V103.01ZM57.7 234.41C80.8 234.41 95.7 230.41 105.8 221.61C115.5 213.31 121.5 200.31 121.5 184.11C121.5 167.01 114.8 152.61 102.6 144.11C91.1 136.01 75.6 134.21 57.4 134.21H47.7V234.41H57.7Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M279.9 151.51H244.8L248.3 174.51H283.4L279.9 151.51Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M249 179.51L262.1 266.41H297.3L284.1 179.51H249Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M12.552 42V7.248H22.248C26.888 7.248 30.328 7.856 32.568 9.072C36.088 10.96 37.848 13.952 37.848 18.048C37.848 21.984 36.232 24.928 33 26.88C30.696 28.256 26.904 28.944 21.624 28.944H18.648V42H12.552ZM18.648 23.856H22.104C25.656 23.856 28.056 23.488 29.304 22.752C30.936 21.792 31.752 20.288 31.752 18.24C31.752 16.064 30.808 14.512 28.92 13.584C27.704 12.976 25.4 12.672 22.008 12.672H18.648V23.856Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M51.4733 33.408C53.7453 35.776 56.5613 36.96 59.9213 36.96C63.2813 36.96 66.0813 35.776 68.3213 33.408C70.5933 31.04 71.7293 28.112 71.7293 24.624C71.7293 21.136 70.5933 18.208 68.3213 15.84C66.0813 13.472 63.2813 12.288 59.9213 12.288C56.5613 12.288 53.7453 13.472 51.4733 15.84C49.2332 18.208 48.1133 21.136 48.1133 24.624C48.1133 28.112 49.2332 31.04 51.4733 33.408ZM72.6893 37.392C69.2653 40.816 65.0093 42.528 59.9213 42.528C54.8333 42.528 50.5773 40.816 47.1533 37.392C43.7293 33.968 42.0173 29.712 42.0173 24.624C42.0173 19.536 43.7293 15.28 47.1533 11.856C50.5773 8.432 54.8333 6.72 59.9213 6.72C65.0093 6.72 69.2653 8.432 72.6893 11.856C76.1133 15.28 77.8253 19.536 77.8253 24.624C77.8253 29.712 76.1133 33.968 72.6893 37.392Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M90.3986 42L79.6946 7.248H86.1746L91.2626 24.144C92.1906 27.216 93.0706 30.272 93.9026 33.312H93.9986C94.5746 31.2 95.4866 28.128 96.7346 24.096L101.967 7.248H106.431L111.663 24.144C112.815 27.824 113.727 30.88 114.399 33.312H114.495C115.551 29.504 116.431 26.432 117.135 24.096L122.223 7.248H128.415L117.663 42H111.183L106.575 27.12C105.423 23.344 104.591 20.56 104.079 18.768H103.983C103.279 21.2 102.463 23.952 101.535 27.024L96.8786 42H90.3986Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M133.323 42V7.248H154.059V12.672H139.419V21.312H152.139V26.496H139.419V36.576H154.539V42H133.323Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M160.954 42V7.248H171.083C175.467 7.248 178.715 7.824 180.827 8.976C184.155 10.768 185.818 13.584 185.818 17.424C185.818 19.792 185.13 21.824 183.755 23.52C182.411 25.216 180.523 26.368 178.09 26.976L188.555 42H181.402L171.706 27.648H167.05V42H160.954ZM167.05 22.944H171.898C174.65 22.944 176.667 22.48 177.947 21.552C179.131 20.688 179.723 19.44 179.723 17.808C179.723 15.92 178.891 14.528 177.227 13.632C176.01 12.992 173.851 12.672 170.747 12.672H167.05V22.944Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M193.133 42V7.248H213.869V12.672H199.229V21.312H211.949V26.496H199.229V36.576H214.349V42H193.133Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M220.765 42V7.248H230.413C236.109 7.248 240.589 8.304 243.853 10.416C246.157 11.888 247.933 13.856 249.181 16.32C250.429 18.784 251.053 21.52 251.053 24.528C251.053 27.344 250.493 29.936 249.373 32.304C248.285 34.672 246.733 36.608 244.717 38.112C241.293 40.704 236.269 42 229.645 42H220.765ZM226.861 36.576H230.173C234.781 36.576 238.221 35.744 240.493 34.08C243.469 31.904 244.957 28.736 244.957 24.576C244.957 22.464 244.525 20.576 243.661 18.912C242.797 17.248 241.629 15.904 240.157 14.88C238.013 13.408 234.669 12.672 230.125 12.672H226.861V36.576Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M269.701 42V7.248H279.397C283.845 7.248 287.125 7.872 289.237 9.12C291.957 10.72 293.317 13.056 293.317 16.128C293.317 19.648 291.573 22.016 288.085 23.232V23.328C290.229 23.872 291.861 24.864 292.981 26.304C294.133 27.712 294.709 29.488 294.709 31.632C294.709 35.216 293.189 37.936 290.149 39.792C287.749 41.264 284.165 42 279.397 42H269.701ZM275.797 22.032H281.221C283.013 22.032 284.453 21.648 285.541 20.88C286.661 20.08 287.221 18.896 287.221 17.328C287.221 15.632 286.501 14.368 285.061 13.536C283.941 12.896 281.925 12.576 279.013 12.576H275.797V22.032ZM275.797 36.672H279.685C283.013 36.672 285.317 36.256 286.597 35.424C287.941 34.56 288.613 33.248 288.613 31.488C288.613 29.824 287.989 28.56 286.741 27.696C285.525 26.832 283.749 26.4 281.413 26.4H275.797V36.672Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<path
			d="M309.792 42V26.304L296.352 7.248H303.456L308.496 14.592C310.288 17.216 311.744 19.392 312.864 21.12H312.96C314.336 19.008 315.808 16.8 317.376 14.496L322.32 7.248H329.184L315.888 26.256V42H309.792Z"
			:fill="white ? 'white' : '#057FCC'"
		/>
		<g clip-path="url(#clip0_2_2)">
			<path
				d="M588.534 159.304C586.054 161.784 582.918 163.024 579.127 163.024C575.337 163.024 572.201 161.784 569.721 159.304C567.24 156.823 566 153.711 566 149.967C566 146.223 567.24 143.111 569.721 140.631C572.201 138.15 575.337 136.91 579.127 136.91C582.918 136.91 586.054 138.15 588.534 140.631C591.015 143.111 592.255 146.223 592.255 149.967C592.255 153.711 591.015 156.823 588.534 159.304ZM571.195 157.9C573.254 159.959 575.898 160.989 579.127 160.989C582.357 160.989 585.001 159.959 587.06 157.9C589.119 155.794 590.149 153.15 590.149 149.967C590.149 146.785 589.119 144.164 587.06 142.105C585.001 139.999 582.357 138.946 579.127 138.946C575.898 138.946 573.254 139.999 571.195 142.105C569.136 144.164 568.106 146.785 568.106 149.967C568.106 153.15 569.136 155.794 571.195 157.9ZM582.216 157.057L579.198 151.933H576.881V157.057H574.354V142.877H579.408C580.906 142.877 582.169 143.298 583.199 144.141C584.229 144.936 584.743 146.036 584.743 147.44C584.743 149.452 583.714 150.833 581.655 151.582L585.094 157.057H582.216ZM576.881 149.757H579.198C581.163 149.757 582.146 148.984 582.146 147.44C582.146 145.942 581.163 145.194 579.198 145.194H576.881V149.757Z"
				:fill="white ? 'white' : '#057FCC'"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2_2">
				<rect width="27" height="27" fill="white" transform="translate(566 136.91)" />
			</clipPath>
		</defs>
	</svg>
	<img
		v-else-if="!config.getConfigContent('logoHide', false)"
		class="object-contain"
		:src="config.config.logo"
		alt=""
	/>
</template>

<script lang="ts" setup>
	import { useConfigStore } from '../../stores/config'

	const props = defineProps<{ clickable?: boolean; white?: boolean }>()

	const config = useConfigStore()

	const onClick = () => {
		if (!props.clickable) return

		let url = `https://www.driveo.com/?utm_source=${config.config.utm_source}&utm_campaign=${config.config.utm_campaign}&utm_term=link`

		if (config.config.utm_medium) {
			url += `&utm_medium=${config.config.utm_medium}`
		}
		if (config.config.location?.shortcode) {
			url += `&loc_physical_ms=${config.config.location.shortcode}`
		}

		window.open(url, '_blank')
	}
</script>
